export default __webpack_public_path__ + "static/media/num-01.ba9b80b6.svg";